import { isPlainObject } from '../miscellaneous/objectHelpers';
import { _destructureProxy, _oneArgumentProxy } from '../miscellaneous/proxies';

export const normalizeNameOfPerson = (...args) => {

    if(!window.Proxy) {
        const [ nameData ] = args;

        const {
            firstName,
            middleName,
            lastName,
            suffix
        } = nameData;

        const isExist = value => (value !== '' && value !== null) ? ` ${value}` : '';

        return `${firstName ? firstName : ''}${isExist(middleName)}${lastName ? ` ${lastName}` : ''}${isExist(suffix)}`;
    }

    const [ nameData ] = _oneArgumentProxy(args);

    if(!(isPlainObject(nameData))) {
        throw new Error('Not an object has been passed to normalizeNameOfPerson function');
    }

    return new window.Proxy(nameData => {

        const {
            firstName,
            middleName,
            lastName,
            suffix
        } = _destructureProxy(nameData);

        const isExist = value => (value !== '' && value !== null) ? ` ${value}` : '';

        return `${firstName ? firstName : ''}${isExist(middleName)}${lastName ? ` ${lastName}` : ''}${isExist(suffix)}`;
    }, {
        apply: function(target, thisArg, argsList) {
            return Reflect.apply(target, thisArg, argsList);
        }
    })(nameData);
};
